import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { includes, without } from 'lodash-es';

import Tooltip from './Tooltip';
import CheckboxWrapper from './CheckboxSet/components/CheckboxWrapper';
import CheckboxLabel from './CheckboxSet/components/CheckboxLabel';
import Checkbox from './CheckboxSet/components/Checkbox';

const CheckboxGroup = ({
  id,
  options,
  active,
  disabled,
  gapCheckbox,
  size,
  withHoverEffect,
  hasCustomBackground = false,
  style,
  className,
  classNameCheckboxWrapper,
  onChange,
}) => {
  const checkboxElements = options.map((option) => {
    const activeCheckboxes = includes(active, option.value)
      ? without(active, option.value)
      : [...active, option.value];
    return (
      <Tooltip
        key={option.value}
        id={option.id}
        placement={
          option.disabled_hover_tooltip && option.tooltipConfig && option.tooltipConfig.position
        }
        colorVariant="light"
        content={option.disabled_hover_tooltip && option.tooltipConfig && option.tooltipConfig.text}
        overlayClassName={!option.disabled_hover_tooltip && 'list-checkbox-menu'}
      >
        <CheckboxWrapper
          id={option.id || `${id}-${option.value}-checkbox`}
          disabled={disabled || option.disabled}
          gap={gapCheckbox || '4px'}
          className={classNameCheckboxWrapper}
        >
          {option.preElement && <CheckboxLabel>{option.preElement}</CheckboxLabel>}
          <Checkbox
            id={option.id || `${id}-${option.value}-checkbox`}
            checked={includes(active, option.value)}
            backgroundColor={hasCustomBackground ? option.backgroundColor : undefined}
            disabled={disabled || option.disabled}
            withHoverEffect={withHoverEffect}
            size={size}
            onChange={() => onChange(activeCheckboxes, option.value)}
          />
          {(option.text || option.subElement) && (
            <CheckboxLabel>
              {option.text}
              {option.subElement}
            </CheckboxLabel>
          )}
        </CheckboxWrapper>
      </Tooltip>
    );
  });
  return (
    <div className={cx(className)} style={style}>
      {checkboxElements}
    </div>
  );
};

CheckboxGroup.propTypes = {
  id: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      disabled: PropTypes.bool,
    })
  ).isRequired,
  active: PropTypes.array.isRequired,
  disabled: PropTypes.bool,
  hasCustomBackground: PropTypes.bool,
  withHoverEffect: PropTypes.string,
  gapCheckbox: PropTypes.string,
  size: PropTypes.string,
  style: PropTypes.object,
  className: PropTypes.string,
  classNameCheckboxWrapper: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default CheckboxGroup;
